import { isMatch } from "./helpers/normalize_keywords";
// splits normalized keywords array into
//   - activityCustomFields - that are safe to pass as custom fields
//   - cfFilters - that are supposed to be saved along { meta: filters } instead
const prepareKeywords = (choosenKeywords, deletedKeywords) => {
  const activityCustomFields = [];

  choosenKeywords.filter(isMatch).forEach(({ type, id, importance }) => {
    let customField = activityCustomFields.find((cf) => cf.type.name === type.name);
    if (!customField) {
      customField = { type, values: [] };
      activityCustomFields.push(customField);
    }
    customField.values.push({ id, importance });
  });

  deletedKeywords.forEach(({ type }) => {
    let customField = activityCustomFields.find((customField) => customField.type.name === type.name);
    if (!customField) {
      customField = { type, values: [] };
      activityCustomFields.push(customField);
    }
  });

  return {
    activityCustomFields
  };
};

export default prepareKeywords;
